import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Tooltip from "../Common/Tooltip";
import { setShowInfo } from "../../AxiosRtk/successMessage";

const DashboardKeyword = ({ getLangTranslation }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isDisabled, setIsDisabled] = useState(true);

  const { latestActivityData, kidList, selectedKidId, selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
  const { recentKeystrokeActivity } = latestActivityData || {};
  const webMonitoringData = recentKeystrokeActivity?.find(
    (item) => item.type === 1
  );
  const setByParent = recentKeystrokeActivity?.find((item) => item.type === 2);
  const useByChild = recentKeystrokeActivity?.find((item) => item.type === 3);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [isDevicesAvailable]);

  const handleCardClick = (event) => {
    // If no device is selected, show an error message and prevent navigation
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; // Stop further action if device is not selected
    }

    // Proceed to the /keyword-stats page if a device is selected
    if (!isDisabled) {
      history.push("/keyword-stats");
    }
  };

  return (
    <div className="col-md-6 mb-6">
      <div className="card h-100">
        <div
          className="card-header d-flex justify-content-between align-items-center cursor-pointer"
          onClick={handleCardClick}
        >
          <h3 className="card-title mb-0">
            {getLangTranslation("CHILD_DETAIL_KEYWORD_STATS", "Keywords stats")}
          </h3>
          <i
            className={`fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
              }`}
            aria-hidden="true"
          ></i>
        </div>
        <div className="card-body">
          <div className="inline-list-wrap separator space-8">
            <div className="list-item d-keyword-stats flex-column align-items-start">
              <p className="text-uppercase mb-3 stats-title">
                {getLangTranslation("SETRULE_WEB_MONITORING", "Web monitoring")}
              </p>
              {webMonitoringData?.maxKeystrokeText &&
                webMonitoringData?.maxCount ? (
                <div className="stats d-flex align-center justify-content-between">
                  <a
                    href={
                      webMonitoringData?.maxKeystrokeText?.startsWith("https")
                        ? webMonitoringData?.maxKeystrokeText
                        : `https://${webMonitoringData?.maxKeystrokeText}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {webMonitoringData?.maxKeystrokeText?.length > 25
                      ? webMonitoringData?.maxKeystrokeText?.substring(0, 25) +
                      "..."
                      : webMonitoringData?.maxKeystrokeText}
                  </a>
                  {webMonitoringData?.maxCount}{" "}
                  {getLangTranslation("CHILD_DETAIL_TIMES", "times")}
                </div>
              ) : (
                <div className="stats d-flex align-center justify-content-between">
                  <span>
                    {getLangTranslation(
                      "PARENT_NOTIFICATION_EMPTY_DATA",
                      "No Data Found"
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="list-item d-keyword-stats flex-column align-items-start">
              <p className="text-uppercase mb-3 stats-title">
                {getLangTranslation(
                  "CHILD_DETAIL_SET_BY_PARENT",
                  "Set by Parent"
                )}
              </p>
              {setByParent?.maxKeystrokeText && setByParent?.maxCount >= 0 ? (
                <Tooltip text={setByParent?.maxKeystrokeText}>
                  <div className="stats d-flex align-center justify-content-between">
                    <span>
                      {setByParent?.maxKeystrokeText?.length > 15
                        ? setByParent?.maxKeystrokeText?.substring(0, 15) +
                        "..."
                        : setByParent?.maxKeystrokeText}
                    </span>
                    {setByParent?.maxCount}{" "}
                    {getLangTranslation("CHILD_DETAIL_TIMES", "times")}
                  </div>
                </Tooltip>
              ) : (
                <div className="stats d-flex align-center justify-content-between">
                  <span>
                    {getLangTranslation(
                      "PARENT_NOTIFICATION_EMPTY_DATA",
                      "No Data Found"
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="list-item d-keyword-stats flex-column align-items-start">
              <p className="text-uppercase mb-3 stats-title">
                {getLangTranslation(
                  "CHILD_DETAIL_USED_BY_CHILD",
                  "Used by Child"
                )}
              </p>
              {useByChild?.maxKeystrokeText && useByChild?.maxCount ? (
                // <div className="stats d-flex align-center justify-content-between">
                //   <span>{useByChild?.maxKeystrokeText}</span>
                //   {useByChild?.maxCount}{" "}
                //   {getLangTranslation("CHILD_DETAIL_TIMES", "times")}
                // </div>
                <Tooltip text={useByChild?.maxKeystrokeText}>
                  <div className="stats d-flex align-center justify-content-between">
                    <span>
                      {useByChild?.maxKeystrokeText?.length > 15
                        ? useByChild?.maxKeystrokeText?.substring(0, 15) + "..."
                        : useByChild?.maxKeystrokeText}
                    </span>
                    {useByChild?.maxCount}{" "}
                    {getLangTranslation("CHILD_DETAIL_TIMES", "times")}
                  </div>
                </Tooltip>
              ) : (
                <div className="stats d-flex align-center justify-content-between">
                  <span>
                    {getLangTranslation(
                      "PARENT_NOTIFICATION_EMPTY_DATA",
                      "No Data Found"
                    )}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <Tooltip />
      </div>
    </div>
  );
};

export default DashboardKeyword;
